export const EVENT_SUCCESS = 'EVENT_SUCCESS';
export const EVENT_ERROR = 'EVENT_ERROR';

export const GET_LANG = 'GET_LANG';
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';

export const GET_CONSTANTS = 'GET_CONSTANTS';
export const GET_EVENT_MASTER = 'GET_EVENT_MASTER';

export const STEP_ONE_STORAGE = 'STEP_ONE_STORAGE';
export const STEP_TWO_STORAGE = 'STEP_TWO_STORAGE';

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';

export const LOGIN_SUCCESS_RECEPTIONIST = 'LOGIN_SUCCESS_RECEPTIONIST';
export const LOGIN_ERROR_RECEPTIONIST = 'LOGIN_ERROR_RECEPTIONIST';

export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_ERROR = 'REGISTER_ERROR';
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const CHECK_AUTHENTICATED = 'CHECK_AUTHENTICATED';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_RECEPTIONIST = 'LOGOUT_RECEPTIONIST';

export const GET_LIST_COMPANY = 'GET_LIST_COMPANY';
export const ACTION_TO_FAVORITE = 'ACTION_TO_FAVORITE';

export const COMPANY_DETAIL = 'COMPANY_DETAIL';
export const PREVIEW_COMPANY_SUCCESS = 'PREVIEW_COMPANY_SUCCESS';
export const PREVIEW_COMPANY_ERROR = 'PREVIEW_COMPANY_ERROR';

export const ME_SUCCESS = 'ME_SUCCESS';
export const ME_ERROR = 'ME_ERROR';

export const UPDATE_INFORMATION_SUCCESS = 'UPDATE_INFORMATION_SUCCESS';
export const UPDATE_INFORMATION_ERROR = 'UPDATE_INFORMATION_ERROR';
export const UPDATE_ENTRY_INFORMATION_SUCCESS =
  'UPDATE_ENTRY_INFORMATION_SUCCESS';

export const UPDATE_ENTRY_INFORMATION_ERROR = 'UPDATE_ENTRY_INFORMATION_ERROR';

export const CHECK_UNAUTHORIZED = 'CHECK_UNAUTHORIZED';
export const CONFIRM_MAIL_SUCCESS = 'CONFIRM_MAIL_SUCCESS';
export const CONFIRM_MAIL_ERROR = 'CONFIRM_MAIL_ERROR';
export const CONFIRM_MAIL_ERROR_RESET = 'CONFIRM_MAIL_ERROR_RESET';

export const UPDATE_SCOUT_MAIL_VIEWED_SUCCESS =
  'UPDATE_SCOUT_MAIL_VIEWED_SUCCESS';

export const UPDATE_READ_FLAG_NOTIFICATION_APPLICANT_SUCCESS =
  'UPDATE_READ_FLAG_NOTIFICATION_APPLICANT_SUCCESS';

export const UPDATE_DISPLAY_FLAG_NOTIFICATION_APPLICANT_SUCCESS =
  'UPDATE_DISPLAY_FLAG_NOTIFICATION_APPLICANT_SUCCESS';

export const UPDATE_READ_FLAG_INFO_LOG_SUCCESS =
  'UPDATE_READ_FLAG_INFO_LOG_SUCCESS';

export const UPDATE_DISPLAY_FLAG_INFO_LOG_SUCCESS =
  'UPDATE_DISPLAY_FLAG_INFO_LOG_SUCCESS';

export const POST_APPLICANT_LOG = 'POST_APPLICANT_LOG';
export const SET_DOMAIN = 'SET_DOMAIN';
export const RESET_REGISTER_STATUS = 'RESET_REGISTER_STATUS';

export const CHECK_EMAIL_SUCCESS = 'CHECK_EMAIL_SUCCESS';
export const CHECK_EMAIL_ERROR = 'CHECK_EMAIL_ERROR';

export const APPLICANT_COMPANY_INTERVIEW = 'APPLICANT_COMPANY_INTERVIEW';

export const CLEAR_REGISTER_DATA = 'CLEAR_REGISTER_DATA';
export const APPLICANT_INTERVIEW_STATUS = 'APPLICANT_INTERVIEW_STATUS';
export const EVENT_INTERVIEW_NOTE = 'EVENT_INTERVIEW_NOTE';

export const SET_TOKEN_FOR_RECEPTIONIST = 'SET_TOKEN_FOR_RECEPTIONIST';
export const ME_SUCCESS_RECEPTIONIST = 'ME_SUCCESS_RECEPTIONIST';
export const ME_ERROR_RECEPTIONIST = 'ME_ERROR_RECEPTIONIST';

export const CHECK_IN_ERROR = 'CHECK_IN_ERROR';
export const CHECK_IN_SUCCESS = 'CHECK_IN_SUCCESS';

export const LIST_CHECK_IN_SUCCESS = 'LIST_CHECK_IN_SUCCESS';
export const LIST_CHECK_IN_ERROR = 'LIST_CHECK_IN_ERROR';

export const SET_CONTRACT_EVENT = 'SET_CONTRACT_EVENT';

export const SEND_INQUIRY = 'SEND_INQUIRY';

export const CLEAR_CHECK_IN_DATA = 'CLEAR_CHECK_IN_DATA';

export const CHECK_UNAUTHORIZED_RECEPTIONIST =
  'CHECK_UNAUTHORIZED_RECEPTIONIST';
export const SET_REGISTRATION_PERIOD_STATUS = 'SET_REGISTRATION_PERIOD_STATUS';

export const LANDING_PAGE_LINK_SUCCESS = 'LANDING_PAGE_LINK_SUCCESS';
export const GET_DATA_EVENT_SCHEDULE_SUCCESS =
  'GET_DATA_EVENT_SCHEDULE_SUCCESS';

export const SET_EVENT_SCHEDULE_SUCCESS = 'SET_EVENT_SCHEDULE_SUCCESS';
